import React, { useEffect, useState } from 'react';
export function AccesoInmediatoSection() {
  const [viewers, setViewers] = useState(93);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(Math.floor(Math.random() * (115 - 90 + 1)) + 90);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <section className="w-full text-center text-white" style={{
    background: '#000000',
    padding: '60px 20px',
    fontFamily: "'Inter', sans-serif"
  }} data-id="element-15">
      {/* Title */}
      <h2 style={{
      fontSize: '28px',
      fontWeight: 700,
      marginBottom: '10px'
    }} data-id="element-16">
        ¡Tu Acceso Inmediato al Método Completo!
      </h2>

      <div style={{
      width: '60px',
      height: '4px',
      background: '#00c853',
      margin: '0 auto 20px auto',
      borderRadius: '4px'
    }} data-id="element-17" />

      <p style={{
      maxWidth: '500px',
      margin: '0 auto 30px auto',
      fontSize: '16px',
      lineHeight: 1.5,
      color: '#d0d0d0'
    }} data-id="element-18">
        Llevate el Método ADN Campeón completo y 5 regalos exclusivos por un
        único pago.
      </p>

      {/* Product Image */}
      <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771287449/2_m2bqoa.png" alt="Método ADN Campeón" style={{
      width: '100%',
      maxWidth: '420px',
      borderRadius: '14px',
      display: 'block',
      margin: '0 auto'
    }} data-id="element-19" />

      <p style={{
      marginTop: '10px',
      color: '#9e9e9e',
      fontSize: '13px'
    }} data-id="element-20">
        +5.200 DESCARGAS
      </p>

      <p style={{
      marginTop: '15px',
      fontSize: '16px',
      fontWeight: 600
    }} data-id="element-21">
        ⚽ Método ADN CAMPEÓN + 5 Regalos Exclusivos 🎁
      </p>

      {/* Price Card */}
      <div style={{
      margin: '25px auto',
      maxWidth: '420px',
      background: 'linear-gradient(145deg, #0d0d0d, #111)',
      borderRadius: '16px',
      padding: '30px 20px',
      border: '1px solid rgba(0,255,150,0.25)',
      boxShadow: '0 0 20px rgba(0,255,150,0.4), 0 0 40px rgba(0,255,150,0.25), 0 0 80px rgba(0,255,150,0.15)'
    }} data-id="element-22">
        <p style={{
        textDecoration: 'line-through',
        color: '#888',
        marginBottom: '8px'
      }} data-id="element-23">
          $67.999 ARS
        </p>

        <h3 style={{
        fontSize: '34px',
        margin: 0,
        color: '#00e676',
        fontWeight: 800
      }} data-id="element-24">
          $17.999 ARS
        </h3>

        <div style={{
        display: 'inline-block',
        marginTop: '12px',
        padding: '6px 14px',
        background: '#00c853',
        borderRadius: '50px',
        fontWeight: 600,
        fontSize: '13px',
        color: '#000'
      }} data-id="element-25">
          AHORRÁ $50.000
        </div>

        <div style={{
        marginTop: '20px',
        fontSize: '14px',
        color: '#ccc'
      }} data-id="element-26">
          ✔ Compra Segura &nbsp;&nbsp; ⚡ Acceso Inmediato
        </div>
      </div>

      {/* Live Viewers Counter */}
      <div aria-live="polite" style={{
      maxWidth: '420px',
      margin: '0 auto 12px auto',
      padding: '14px',
      background: '#111',
      borderRadius: '10px',
      fontSize: '15px',
      border: '1px solid rgba(255,255,255,0.1)'
    }} data-id="element-27">
        {viewers} personas están viendo esta oferta
      </div>

      {/* Last Spots */}
      <div style={{
      maxWidth: '420px',
      margin: '0 auto 15px auto',
      padding: '14px',
      background: '#d50000',
      borderRadius: '10px',
      fontWeight: 600,
      fontSize: '15px'
    }} data-id="element-28">
        ● ¡Últimos 5 Cupos en Oferta!
      </div>

      {/* Main CTA Button */}
      <a href="https://infoliar.com/cart/56736084721996:1" className="adn-glow-pulse-btn" style={{
      display: 'block',
      width: '100%',
      maxWidth: '420px',
      margin: '0 auto',
      padding: '18px',
      background: '#00c853',
      color: '#000',
      fontWeight: 700,
      borderRadius: '50px',
      border: 'none',
      fontSize: '16px',
      cursor: 'pointer',
      textDecoration: 'none',
      textAlign: 'center',
      boxSizing: 'border-box'
    }} aria-label="Quiero asegurar mi lugar - Comprar ahora" data-id="element-29">
        ¡QUIERO ASEGURAR MI LUGAR!
      </a>
    </section>;
}